import type { SVGProps } from 'react';

export interface ShigoWordmarkProps extends Omit<SVGProps<HTMLSpanElement>, 'width' | 'height'> {
  height?: number;
  label?: string;
}

export function ShigoWordmark({
  height = 20,
  label = 'Shigo',
  className,
  ...props
}: ShigoWordmarkProps) {
  return (
    <span aria-label={label} className={className} style={{ minHeight: height }} {...props}>
      <span className="text-primary text-lg font-semibold tracking-normal">Shigo</span>
    </span>
  );
}
